import React from 'react';
import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from "@mui/material";
import { WarningAmberRounded } from "@mui/icons-material";

const _SupportCloseDialog = ({
    open,
    onClose,
    closing,
    onConfirmClose,
}) => {
    return (
        <Dialog
            open={open}
            onClose={() => !closing && onClose()}
            maxWidth="xs"
            fullWidth
            PaperProps={{ sx: { borderRadius: 3.5, p: 1 } }}
        >
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1.5, pb: 1 }}>
                <WarningAmberRounded color="warning" sx={{ fontSize: 28 }} />
                <Typography variant="h6" sx={{ fontWeight: 800 }}>
                    بستن تیکت پشتیبانی
                </Typography>
            </DialogTitle>
            <DialogContent>
                <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.8 }}>
                    آیا از لغو یا بستن این تیکت اطمینان دارید؟ پس از بستن، مکالمه خاتمه یافته و در صورت نیاز باید تیکت جدیدی ثبت کنید.
                </Typography>
            </DialogContent>
            <DialogActions sx={{ px: 2, pb: 2, gap: 1 }}>
                <Button
                    variant="outlined"
                    onClick={onClose}
                    disabled={closing}
                    sx={{ borderRadius: 2 }}
                >
                    انصراف
                </Button>
                <Button
                    variant="contained"
                    color="error"
                    onClick={onConfirmClose}
                    disabled={closing}
                    startIcon={closing && <CircularProgress size={16} color="inherit" />}
                    sx={{ borderRadius: 2, fontWeight: 700 }}
                >
                    {closing ? "در حال بستن..." : "بله، تیکت بسته شود"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default _SupportCloseDialog;
